import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, { useEffect } from 'react';
import { LoginPage } from './pages/Login';
import { ExpressPage } from "./pages/ExpressPage";
import { DepositsPage } from './pages/Deposits';
import { DepositsCreditCardPage } from './pages/DepositsCreditCard';
import { DepositsZellePage } from './pages/DepositZelle';
import { DepositsP2PPage } from './pages/DepositsP2P';
import { DepositCryptoPage } from './pages/DepositCrypto';
import { DepositEwalletPage } from './pages/DepositEwallet';
import { DepositECheckPage } from './pages/DepositCheck';
import { DepositGenericPage } from './pages/DepositGeneric';
import { DepositTwoStepPage } from './pages/DepositTwoStep';
import { DepositQuickerACHPage } from './pages/DepositQuickerACH';
import { DepositR4ConectaPage } from './pages/DepositR4Conecta';
import { DepositR4DebitoInmediatoPage } from './pages/DepositR4DebitoInmediato';
import { DepositPaycashPage } from './pages/DepositPaycash';
import { PayoutsPage } from './pages/Payouts';
import { PayoutCryptoPage } from './pages/PayoutCrypto';
import { PayoutWalletPage } from './pages/PayoutWallet';
import { PayoutR4ConectaPage } from './pages/PayoutR4Conecta';
import { PayoutGenericPage } from './pages/PayoutGeneric';
import { PayoutCheckPage } from './pages/PayoutCheck';
import { PayoutACHPage } from './pages/PayoutACH';
import { PayoutWireTransferPage } from './pages/PayoutWireTransfer';
import { PayoutP2PPage } from './pages/PayoutP2P';
import { ExpiredPage } from './pages/expired';
import { PayoutHistoryPage } from './pages/PayoutHistory'
import { MissingPage } from './pages/MissingInfo';
import { LanguageProvider } from './context/LanguageContext'




function App() {
    //const client = new QueryClient();
    useEffect(() => {
        let timeout;

        const observer = new ResizeObserver(() => {
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(() => {
                window.parent.postMessage(
                    { 'full-content-height': document.body.scrollHeight + 35 },
                    '*'
                );
            }, 400);
        });

        if (document.body) {
            observer.observe(document.body);
        }

        return () => {
            observer.disconnect();
            if (timeout) {
                clearTimeout(timeout);
            }
        };
    }, []);


    return (
        <LanguageProvider>
            <BrowserRouter basename="/">
                <Routes>
                    <Route path="/" element={<LoginPage />} />
                    <Route path="/main/" element={<ExpressPage />} />
                    <Route path="/missing/" element={<MissingPage />} />
                    <Route path="/deposits/:id" element={<DepositsPage />} />
                    <Route path="/deposits/" element={<DepositsPage />} />
                    <Route path="/deposits/creditcard/:id" element={<DepositsCreditCardPage />} />
                    <Route path="/deposits/zelle/:id" element={<DepositsZellePage />} />
                    <Route path="/deposits/p2p/:id" element={<DepositsP2PPage />} />
                    <Route path="/deposits/crypto/:id" element={<DepositCryptoPage />} />
                    <Route path="/deposits/ewallet/:id" element={<DepositEwalletPage />} />
                    <Route path="/deposits/check/" element={<DepositECheckPage />} />
                    <Route path="/deposits/generic/:id" element={<DepositGenericPage />} />
                    <Route path="/deposits/dualstep/:id" element={<DepositTwoStepPage />} />
                    <Route path="/deposits/quickerach/:id" element={<DepositQuickerACHPage />} />
                    <Route path="/deposits/r4conecta/:id" element={<DepositR4ConectaPage />} />
                    <Route path="/deposits/r4debitoinmediato/:id" element={<DepositR4DebitoInmediatoPage />} />
                    <Route path="/deposits/paycash/:id" element={<DepositPaycashPage />} />
                    <Route path="/payouts/" element={<PayoutsPage />} />
                    <Route path="/payoutHistory/" element={<PayoutHistoryPage />} />
                    <Route path="/payouts/crypto/:id" element={<PayoutCryptoPage />} />
                    <Route path="/payouts/wallet/:id" element={<PayoutWalletPage />} />
                    <Route path="/payouts/r4conecta/:id" element={<PayoutR4ConectaPage />} />
                    <Route path="/payouts/generic/:id" element={<PayoutGenericPage />} />
                    <Route path="/payouts/moneygram/" element={<PayoutP2PPage />} />
                    <Route path="/payouts/check/:id" element={<PayoutCheckPage />} />
                    <Route path="/payouts/ach/:id" element={<PayoutACHPage />} />
                    <Route path="/payouts/wiretransfer/:id" element={<PayoutWireTransferPage />} />
                    <Route path="/expired/" element={<ExpiredPage/> } />
                </Routes>
            </BrowserRouter>
        </LanguageProvider>
    );
}

export default App;
